import {alias, createModelSchema, reference} from "serializr";

import {TriggerBase} from "./core/TriggerBase";
import {TriggerKind} from "./core/TriggerKind";
import {TriggerScope} from "./core/TriggerScope";
import {RedactorUtils} from "../../core/RedactorUtils";
import {Schema} from "@/common/Schema";

export class TriggerSmartOffer extends TriggerBase {

    constructor() {
        super(TriggerKind.SMART_OFFER);

        this._amount = 0;
        this._lifetime = 0;
        this._offerUID = null;
    }

    get offerUID() {
        return this._offerUID;
    }

    set offerUID(value) {
        this._offerUID = value;
    }

    get lifetime() {
        return this._lifetime;
    }

    set lifetime(value) {
        this._lifetime = value;
    }

    valid() {

        if (!super.valid()) {
            return false;
        }

        if (!this.offerUID || !RedactorUtils.getSmartOffer(this.offerUID)) {
            return false;
        }

        if (this.scope && (this.scope.id === 5 || this.scope.id === 6)) {
            if (!Number.isInteger(this.lifetime) || this.lifetime <= 0) {
                return false;
            }
        } else {
            this.lifetime = 0;
        }

        return true;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new TriggerSmartOffer());
        } else if (target instanceof TriggerSmartOffer) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

export class TriggerSmartOfferScope extends TriggerScope {
    static _values = [
        new TriggerSmartOfferScope(1, "AVAILABLE"),
        new TriggerSmartOfferScope(2, "ACTIVE"),
        new TriggerSmartOfferScope(3, "PASSED"),
        new TriggerSmartOfferScope(4, "CLOSED"),
        new TriggerSmartOfferScope(7, "LOCKED"),

        new TriggerSmartOfferScope(8, "EXPIRED"),
        new TriggerSmartOfferScope(9, "EXTEND"),
        new TriggerSmartOfferScope(10, "ACTIVE_EXTEND"),

        new TriggerSmartOfferScope(5, "ACTIVE_LIFETIME_GREAT"),
        new TriggerSmartOfferScope(6, "ACTIVE_LIFETIME_LESS")
    ];

    static getValues() {
        return this._values;
    }

    static getValue(id) {
        let value = this._values.find(v => v.id === id) || null;
        console.assert(value, "unknown id: " + id);
        return value;
    }

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, TriggerSmartOfferScope.getValue(id));
        });
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new TriggerSmartOfferScope());
        } else if (target instanceof TriggerSmartOfferScope) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(TriggerSmartOffer, {
    _scope: alias("scope", TriggerSmartOfferScope.schema()),
    _lifetime: alias("lifetime", Schema.primitive()),
    _offerUID: alias("offer_uid", Schema.primitive())
});